import { render } from "./GestioneDepositi.vue?vue&type=template&id=a0ed389e&scoped=true"
import script from "./GestioneDepositi.vue?vue&type=script&lang=js"
export * from "./GestioneDepositi.vue?vue&type=script&lang=js"

import "./GestioneDepositi.vue?vue&type=style&index=0&id=a0ed389e&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0ed389e"]])

export default __exports__